import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { FaRegComment } from "react-icons/fa";

import useVideoContext from "../../hooks/useVideoContext/useVideoContext";
import { ActionIconButton } from "../ActionIconButton";
import { CommentButtonModal } from "./CommentButtonModal";

type CommentButtonProps = {
  anchorEl?: HTMLElement | null;
  isOpen?: boolean;
  hours: number;
  minutes: number;
  seconds: number;
  onClose?: () => void;
};

const CommentButton = ({ hours, minutes, seconds }: CommentButtonProps) => {
  const { t: translate } = useTranslation();

  const { room, participantsAllowed } = useVideoContext();

  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  return (
    <>
      <ActionIconButton
        dataCy="commentAction"
        disabled={!room || participantsAllowed?.length === 0}
        onClick={() => setIsOpenModal(true)}
        tooltipTitle={translate("saveAComment")}
      >
        <FaRegComment />
      </ActionIconButton>

      <CommentButtonModal
        isOpen={isOpenModal}
        hours={hours}
        minutes={minutes}
        seconds={seconds}
        onClose={() => setIsOpenModal(false)}
      />
    </>
  );
};

export default CommentButton;
